import { useEffect, useState, useRef } from "react";
import { NumericFormat } from "react-number-format";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useReactToPrint } from "react-to-print";
import { reportCRUD } from "../../actions/report";
import { PrintHeader } from "../../layout/PrintHeader";

export const Report1 = () => {
  const tableRef = useRef(null);
  const dataRef = useRef(null);

  const [dataMale, setDataMale] = useState([]);
  const [dataFemale, setDataFemale] = useState([]);
  const [dataKaya, setDataKaya] = useState([]);
  const [dataHeadFemale, setDataHeadFemale] = useState([]);
  const [dataBirth, setDataBirth] = useState([]);
  const [dataDeath, setDataDeath] = useState([]);
  const [dataPopulation, setDataPopulation] = useState([]);
  const [pCheck, setPCheck] = useState(false);
  const [mCheck, setMCheck] = useState(false);
  const [bCheck, setBCheck] = useState(false);
  const [dCheck, setDCheck] = useState(false);
  const [disabled, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (pCheck) {
      setDisable(false);
    } else if (mCheck) {
      setDisable(false);
    } else if (bCheck) {
      setDisable(false);
    } else if (dCheck) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [pCheck, mCheck, bCheck, dCheck]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
      reportCRUD
        .loadMemberPopulationReport()
        .then((resp) => {
          setDataMale(resp.data.result_male);
          setDataFemale(resp.data.result_female);
          setDataKaya(resp.data.total_household);
          setDataHeadFemale(resp.data.household_female_head);
          setDataBirth(resp.data.new_birth);
          setDataDeath(resp.data.death);
          setDataPopulation(resp.data.total_population);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, []);

  const handleGeneratePdf = useReactToPrint({
    content: () => dataRef.current,
  });

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Summary Report</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="#">Report</a>
                      </li>
                      <li className="breadcrumb-item active">Form 1</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    {loading ? (
                      <div className="d-flex justify-content-center">
                        <div
                          class="spinner-grow spinner-grow-sm text-primary me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-secondary me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-success me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-info me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-warning me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-danger me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-dark me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                        <div
                          class="spinner-grow spinner-grow-sm text-light me-1"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-md-9">
                          <div className="row d-flex justify-content-start">
                            <div className="col-auto">
                              <div className="form-check form-check-outline form-check-secondary mt-3 checkbox-lg">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="formCheck6"
                                  onClick={() => setPCheck(!pCheck)}
                                />
                                <label
                                  className="form-check-label fs-5 mt-1"
                                  for="formCheck6"
                                >
                                  Population
                                </label>
                              </div>
                            </div>
                            <div className="col-auto">
                              <div className="form-check form-check-outline form-check-info mt-3 checkbox-lg">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="formCheck6"
                                  onClick={() => setMCheck(!mCheck)}
                                />
                                <label
                                  className="form-check-label fs-5 mt-1"
                                  for="formCheck6"
                                >
                                  Migration
                                </label>
                              </div>
                            </div>
                            <div className="col-auto">
                              <div className="form-check form-check-outline form-check-success mt-3 checkbox-lg">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="formCheck6"
                                  onClick={() => setBCheck(!bCheck)}
                                />
                                <label
                                  className="form-check-label fs-5 mt-1"
                                  for="formCheck6"
                                >
                                  Birth
                                </label>
                              </div>
                            </div>
                            <div className="col-auto">
                              <div className="form-check form-check-outline form-check-danger mt-3 checkbox-lg">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="formCheck6"
                                  onClick={() => setDCheck(!dCheck)}
                                />
                                <label
                                  className="form-check-label fs-5 mt-1"
                                  for="formCheck6"
                                >
                                  Death
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="row d-flex justify-content-end">
                            <div className="col-auto">
                              <button
                                type="button"
                                className="btn btn-soft-danger"
                                disabled={disabled}
                                onClick={handleGeneratePdf}
                              >
                                <i className="bi bi-file-earmark-pdf bi-lg"></i>
                                &nbsp; PDF
                              </button>
                            </div>
                            <div className="col-auto">
                              <button
                                type="button"
                                className="btn btn-soft-success"
                                disabled={disabled}
                              >
                                <DownloadTableExcel
                                  filename="report form1"
                                  sheet="form1"
                                  currentTableRef={tableRef.current}
                                >
                                  <i className="bi bi-file-earmark-excel bi-lg"></i>
                                  &nbsp; Excel
                                </DownloadTableExcel>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="card-body" ref={dataRef}>
                    <PrintHeader subtitle="Demographic Report" />
                    <table
                      ref={tableRef}
                      id="scroll-vertical"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "80px" }}>SR No.</th>
                          <th className="d-flex justify-content-center">
                            Description
                          </th>
                          <th style={{ width: "180px" }}>Male</th>
                          <th style={{ width: "180px" }}>Female</th>
                          <th style={{ width: "180px" }}>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pCheck && (
                          <>
                            <tr>
                              <td className="text-end">{pCheck && 1}</td>
                              <td colSpan={4}>Population</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total population age 0 - 5</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[0].total_0_5 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[0].total_0_5 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[0].total_0_5 +
                                        dataFemale[0].total_0_5
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total population age 6 - 10</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[1].total_6_10 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[1].total_6_10 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[1].total_6_10 +
                                        dataFemale[1].total_6_10
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total population age 15 - 19</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[2].total_15_19 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[2].total_15_19 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[2].total_15_19 +
                                        dataFemale[2].total_15_19
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total population age 20 - 25</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[3].total_20_25 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[3].total_20_25 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[3].total_20_25 +
                                        dataFemale[3].total_20_25
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total population age 26 - 30</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[4].total_26_30 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[4].total_26_30 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[4].total_26_30 +
                                        dataFemale[4].total_26_30
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total population age 31 - 35</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[5].total_31_35 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[5].total_31_35 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[5].total_31_35 +
                                        dataFemale[5].total_31_35
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total population age 36 - 45</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[6].total_36_45 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[6].total_36_45 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[6].total_36_45 +
                                        dataFemale[6].total_36_45
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total population age 46 - 55</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[7].total_46_55 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[7].total_46_55 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[7].total_46_55 +
                                        dataFemale[7].total_46_55
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total population age 56 - 65</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataMale ? dataMale[8].total_56_65 : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataFemale ? dataFemale[8].total_56_65 : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataMale && dataFemale
                                      ? dataMale[8].total_56_65 +
                                        dataFemale[8].total_56_65
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td colSpan={4}></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total population</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataPopulation ? dataPopulation[0] : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataPopulation ? dataPopulation[1] : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataPopulation
                                      ? dataPopulation[0] + dataPopulation[1]
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td colSpan={4}></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of household</td>
                              <td className="text-end" colSpan={3}>
                                <NumericFormat
                                  value={dataKaya ? dataKaya[0] : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td colSpan={4}></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of household</td>
                              <td colSpan={3} className="text-end">
                                <NumericFormat
                                  value={dataHeadFemale ? dataHeadFemale[0] : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                          </>
                        )}

                        {mCheck && (
                          <>
                            <tr>
                              <td className="text-end">{pCheck ? 2 : 1}</td>
                              <td colSpan={4}>Migration</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Immigrants age 0 - 5</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Immigrants age 6 - 10</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Immigrants age 15 - 19</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Immigrants age 20 - 25</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Immigrants age 26 - 30</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Immigrants age 31 - 35</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Immigrants age 36 - 45</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Immigrants age 46 - 55</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Immigrants age 56 - 60</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>

                            <tr>
                              <td></td>
                              <td colSpan={4}></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Emigrants 0 - 5</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Emigrants 6 - 10</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Emigrants 15 - 19</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Emigrants 20 - 25</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Emigrants 26 - 30</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Emigrants 31 - 35</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Emigrants 36 - 45</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Emigrants 46 - 55</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of Emigrants 56 - 60</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                              <td className="text-end">0</td>
                            </tr>
                          </>
                        )}

                        {bCheck && (
                          <>
                            <tr>
                              <td className="text-end">
                                {pCheck && mCheck
                                  ? 3
                                  : pCheck && !mCheck
                                  ? 2
                                  : !pCheck && mCheck
                                  ? 2
                                  : 1}
                              </td>
                              <td colSpan={4}>Birth</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of birth by year</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataBirth ? dataBirth[0].male : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={dataBirth ? dataBirth[1].female : 0}
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataBirth
                                      ? dataBirth[0].male + dataBirth[1].female
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                          </>
                        )}

                        {dCheck && (
                          <>
                            <tr>
                              <td className="text-end">
                                {pCheck && mCheck && bCheck
                                  ? 4
                                  : pCheck && !mCheck && bCheck
                                  ? 3
                                  : pCheck && mCheck && !bCheck
                                  ? 3
                                  : !pCheck && mCheck && bCheck
                                  ? 3
                                  : pCheck && !mCheck && !bCheck
                                  ? 2
                                  : !pCheck && mCheck && !bCheck
                                  ? 2
                                  : !pCheck && !mCheck && bCheck
                                  ? 2
                                  : 1}
                              </td>
                              <td colSpan={4}>Death</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of maternal deaths</td>
                              <td className="text-end" colSpan={3}>
                                <NumericFormat
                                  value={
                                    dataDeath
                                      ? dataDeath[2].total_maternal_death
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>Total number of deaths children age 0 - 5</td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataDeath ? dataDeath[0].total_0_5_male : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataDeath
                                      ? dataDeath[1].total_0_5_female
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                              <td className="text-end">
                                <NumericFormat
                                  value={
                                    dataDeath
                                      ? dataDeath[0].total_0_5_male +
                                        dataDeath[1].total_0_5_female
                                      : 0
                                  }
                                  displayType="text"
                                  thousandSeparator
                                  prefix=""
                                  renderText={(value) => <span>{value}</span>}
                                />
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
